import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage } from 'react-intl';

const TextOnly = (props) => {
    const { content } = props;
    return(
        <div
          className="textonly"
          data-key={ content.dataKey }
          id={ content.dataKey }
        >
          <FormattedHTMLMessage
            id={ content.dataKey }
            defaultMessage={ content.text }
          />
        </div>
    )
}

TextOnly.propTypes = {
    content: PropTypes.object
};
TextOnly.defaultProps = {
    content: {
        text: '',
        dataKey: 'textonly'
    }
};

export default TextOnly;


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/TextOnly/index.js